var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFridge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 12.1867L16.2102 13.005L18.6833 14.4733L17.9059 15.925L15.4327 14.4567L16.2102 17.3933L14.6854 17.84L13.4821 13.3L10.2917 11.4233V14.655L13.4583 17.9883L12.3389 19.1667L10.2917 17.0117V20H8.70833V17.0117L6.66108 19.1667L5.54167 17.9883L8.70833 14.655V11.4233L5.51792 13.3L4.313 17.84L2.78825 17.3933L3.56567 14.4567L1.0925 15.9267L0.315083 14.475L2.78825 13.0067L0 12.1867L0.425917 10.5833L4.7405 11.85L7.87867 10L4.73892 8.15167L0.425917 9.41667L0 7.81333L2.78983 6.995L0.315083 5.525L1.0925 4.07333L3.56567 5.54167L2.78983 2.605L4.31458 2.15667L5.51792 6.69833L8.70833 8.57833V5.345L5.54167 2.01167L6.66108 0.833333L8.70833 2.98833V0H10.2917V2.98833L12.3389 0.833333L13.4583 2.01167L10.2917 5.345V8.57833L13.4837 6.7L14.687 2.15833L16.2118 2.60667L15.4327 5.54167L17.9059 4.07333L18.6833 5.525L16.2102 6.99333L19 7.81333L18.5741 9.41667L14.2595 8.15L11.1213 10L14.2595 11.8483L18.5741 10.5817L19 12.1867Z",
    fill: "#3394F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFridge);
export default __webpack_public_path__ + "static/media/fridge.07e5af8511ab3984ffd71fba80a3b832.svg";
export { ForwardRef as ReactComponent };